import { Directive, TemplateRef, inject } from '@angular/core';
import { HeaderCellContextType } from '../models/table-context.model';

@Directive({ selector: '[fr8botUiTableHeaderCellDef]' })
export class TableHeaderCellDefUIDirective {
  templateRef = inject<TemplateRef<HeaderCellContextType>>(TemplateRef);

  static ngTemplateContextGuard(
    dir: TableHeaderCellDefUIDirective,
    ctx: unknown,
  ): ctx is HeaderCellContextType {
    return true;
  }
}
